import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _create_class from "@swc/helpers/src/_create_class.mjs";
export var LegacyStage = /*#__PURE__*/ function() {
    "use strict";
    function LegacyStage(content) {
        _class_call_check(this, LegacyStage);
        this.content = content;
        this.type = "legacy";
    }
    _create_class(LegacyStage, [
        {
            key: "keyword",
            get: function get() {
                return this.content.mainKeyword;
            }
        },
        {
            key: "image",
            get: function get() {
                var ref;
                return (ref = this.content.stage) === null || ref === void 0 ? void 0 : ref.image;
            }
        },
        {
            key: "headline",
            get: function get() {
                var ref;
                return ((ref = this.content.stage) === null || ref === void 0 ? void 0 : ref.headline) || "";
            }
        },
        {
            key: "includeSearch",
            get: function get() {
                var ref;
                return ((ref = this.content.stage) === null || ref === void 0 ? void 0 : ref.includeSearch) || false;
            }
        },
        {
            key: "pageTitle",
            get: function get() {
                var ref;
                return ((ref = this.content.stage) === null || ref === void 0 ? void 0 : ref.pageTitle) || "";
            }
        }
    ]);
    return LegacyStage;
}();
